import { en } from "./en.js";
import { es } from "./es.js";
import { pt } from "./pt.js";
export * from "./constants.js";
export * from "./types.js";
const locales = {
    es: es,
    en: en,
    pt: pt
};
const i18n = locales;
export default i18n;
